module.exports = __webpack_public_path__ + "media/packs/landing_page/images/Youtube-62688e3c4b43e7a7cc901aead3c0fb9c.png";